"use strict";

import React from "react";
import cx from "classnames";

function Panel(props) {
  const { baseClassName, className, children, ...other } = props;

  return (
    <div className={cx(baseClassName, className)} {...other}>
      {children}
    </div>
  );
}

Panel.defaultProps = {
  baseClassName: "si-c-panel",
};

export default Panel;
